const getGlobalState = (state, key) => (Array.isArray(state.oddsHistory[key]) ? state.oddsHistory[key].slice(0) : state.oddsHistory[key]);

export const getMatchId = (state) => getGlobalState(state, 'matchId');
export const getSelectedMarkets = (state) => getGlobalState(state, 'selectedMarkets');
export const getOddDetails = (state) => getGlobalState(state, 'oddsDetails');
export const getTennisOddDetails = (state) => getGlobalState(state, 'tennisOddsDetails');
export const getMarketsDisplayed = (state) => getGlobalState(state, 'marketsDisplayed');
export const getTennisMarketsDisplayed = (state) => getGlobalState(state, 'tennisMarketsDisplayed');
export const getDownloadedExcelFile = (state) => getGlobalState(state, 'downloadedExcelFile');
export const getDownloadedTennisExcelFile = (state) => getGlobalState(state, 'downloadedTennisExcelFile');
